// extracted by mini-css-extract-plugin
export default {"wrapper":"TextBuilder_wrapper__-C+A7","title":"TextBuilder_title__n6HLj","description":"TextBuilder_description__SyQBM"};